export default __webpack_public_path__ + "static/media/1314 spice rack side.bb94865f.png";